import React from "react";
import { IMessageParts } from "../../interfaces";


const ChatMessagePlainTextBody = ({messageText, id}: {messageText:IMessageParts[], id:number}) => {
    /**
     * This will need to be extended as we introduce more type, it's pretty primitive right now
     */
    return <p>
         {messageText.map((part, index) => (
            <React.Fragment key={`message-${id}-fragment-${index}`}>
            {part.type === "linebreak"
                ? <br />
                : <>{part.text}</>
            }
        </React.Fragment>
      ))}
    </p>
}

export default ChatMessagePlainTextBody